var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4701 1.94469H18.1621C18.9315 1.94469 19.5552 2.56841 19.5552 3.33781V9.02983C19.5552 9.3993 19.4084 9.75365 19.1471 10.0149L9.74357 19.4185C9.19951 19.9625 8.31744 19.9625 7.77338 19.4185L2.08138 13.7265C1.53733 13.1824 1.53733 12.3004 2.08138 11.7563L11.485 2.35272C11.7462 2.09146 12.1006 1.94469 12.4701 1.94469Z",
    stroke: "#FF0000",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0276 7.16891C14.6429 7.16891 14.3311 6.85705 14.3311 6.47235C14.3311 6.08765 14.6429 5.77579 15.0276 5.77579C15.4123 5.77579 15.7242 6.08765 15.7242 6.47235C15.7242 6.85705 15.4123 7.16891 15.0276 7.16891Z",
    stroke: "#FF0000",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogout);
export default __webpack_public_path__ + "static/media/sidebarLogout.da5c583d62f491aaba1694be0ac49bbf.svg";
export { ForwardRef as ReactComponent };